import React from 'react';
import {
  Flex,
  Image,
  LinkBox,
  LinkOverlay,
  useStyleConfig,
} from '@chakra-ui/react';
import { brandURL } from '../../config';
import logoSRC from '../../assets/branding/logo-white.svg';

const LateralMenu = (props) => {
  const { children, variant, ...contentProps } = props;
  const style = useStyleConfig('LateralMenu', { variant });

  return (
    <Flex __css={style.menu} {...contentProps}>
      <LinkBox justifyContent="center">
        <LinkOverlay href={brandURL} target="_blank">
          <Image __css={style.brand} src={logoSRC} />
        </LinkOverlay>
      </LinkBox>
      {children}
    </Flex>
  );
};

export default LateralMenu;
